import React, { useContext, useEffect, useRef, useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import secureLocalStorage from 'react-secure-storage';
import { MyContext } from '../../Context/MyProvider';
import PageLoading from '../PageLoading';
import { useTranslation } from 'react-i18next';
import axios from 'axios';
import Btn_loader from '../Btn_loader';

const Dashboard = () => {

  const { t } = useTranslation();
  const { setIsToast, setToastMsg, setIsAuth, setUserLogin, HandleCallApi, formatPrice, BaseUrl } = useContext(MyContext);

  const [loading, setLoading] = useState(true);
  const [name, setName] = useState("");
  const [date, setDate] = useState("");
  const [pageList, setPageList] = useState([]);
  const [savedKundlis, setSavedKundlis] = useState([]);
  const [downloadingPdfId, setDownloadingPdfId] = useState(null);
  const [showConfirmModal, setShowConfirmModal] = useState(false);
  const [pendingKundli, setPendingKundli] = useState(null);

  const Userwallet = Number(secureLocalStorage.getItem("userwallet") || 0);
  const Currency = secureLocalStorage.getItem("currency") || "$";
  const Userid = secureLocalStorage.getItem("Userid");

  const navigate = useNavigate();

  const formatDateSafe = (dateStr) => {
    if (!dateStr || dateStr === '0000-00-00' || dateStr === '0000-00-00 00:00:00') return "N/A";
    try {
      const d = new Date(dateStr);
      if (isNaN(d.getTime())) return dateStr;
      return d.toLocaleDateString('en-IN', { day:'2-digit', month:'short', year:'numeric' });
    } catch {
      return dateStr;
    }
  };
  const PageListRef = useRef(false);

  const CardList = [
    {
      title: "Chat With Astrologer", path: "/chat-width-astrologer", color: 'bg-gradient-to-br from-blue-500 to-blue-600', icon: <svg width="24" height="24" className="w-6 h-6 text-white" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M8 14H16M8 10H12M21.9664 11.2166C21.9886 11.4748 22 11.7361 22 12C22 16.9706 17.9706 21 13 21H6C3.79086 21 2 19.2091 2 17V12C2 7.02944 6.02944 3 11 3H13C13.2639 3 13.5252 3.01136 13.7834 3.03362M22 6C22 7.65685 20.6569 9 19 9C17.3431 9 16 7.65685 16 6C16 4.34315 17.3431 3 19 3C20.6569 3 22 4.34315 22 6Z" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" />
      </svg>

    },
    {
      title: "Appointment List", path: "/appointment-list", color: 'bg-gradient-to-br from-teal-500 to-teal-600', icon: <svg width="24" height="24" className="w-6 h-6 text-white" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M3 7.5C3 5.29086 4.79086 3.5 7 3.5H17C19.2091 3.5 21 5.29086 21 7.5V18C21 20.2091 19.2091 22 17 22H7C4.79086 22 3 20.2091 3 18V7.5Z" stroke="currentColor" strokeWidth="1.5" />
        <path d="M3 9H21" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" />
        <path d="M8 2L8 5" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
        <path d="M16 2V5" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
        <circle cx="12" cy="15" r="1" fill="currentColor" />
        <circle cx="16" cy="15" r="1" fill="currentColor" />
        <circle cx="8" cy="15" r="1" fill="currentColor" />
      </svg>

    },
    {
      title: "My Following", path: "/following", color: 'bg-gradient-to-br from-violet-500 to-violet-600', icon: <svg width="24" height="24" className="w-6 h-6 text-white" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M16.08 10.389C16.196 9.99204 16.611 9.764 17.011 9.88C17.102 9.907 17.209 9.92004 17.34 9.92004C18.211 9.92004 18.92 9.20696 18.92 8.32996C18.92 7.61296 18.436 6.98603 17.741 6.80603C17.34 6.70203 17.099 6.29199 17.204 5.89099C17.307 5.48999 17.714 5.25203 18.118 5.35303C19.473 5.70503 20.42 6.92898 20.42 8.32898C20.42 10.033 19.038 11.4189 17.34 11.4189C17.065 11.4189 16.819 11.386 16.589 11.319C16.191 11.203 15.964 10.787 16.08 10.389ZM18.897 11.931C18.887 11.931 18.878 11.931 18.87 11.931C18.468 11.931 18.135 12.2491 18.121 12.6541C18.105 13.0681 18.429 13.4151 18.843 13.4301C21.076 13.5111 21.25 15.425 21.25 16.01V18C21.25 18.414 21.586 18.75 22 18.75C22.414 18.75 22.75 18.414 22.75 18V16.01C22.75 14.192 21.741 12.033 18.897 11.931ZM6.67004 11.42C6.94504 11.42 7.19102 11.3869 7.42102 11.3199C7.81802 11.2029 8.04605 10.787 7.93005 10.389C7.81405 9.99204 7.39802 9.764 6.99902 9.88C6.90802 9.907 6.80104 9.92004 6.67004 9.92004C5.79904 9.92004 5.08997 9.20696 5.08997 8.32996C5.08997 7.60696 5.57795 6.97602 6.27795 6.79602C6.67795 6.69302 6.92102 6.28406 6.81702 5.88306C6.71302 5.48106 6.30295 5.23799 5.90295 5.34399C4.54195 5.69499 3.59094 6.92296 3.59094 8.32996C3.58994 10.034 4.97204 11.42 6.67004 11.42ZM5.85901 12.65C5.84201 12.236 5.50196 11.909 5.07996 11.931C2.25296 12.045 1.25 14.2 1.25 16.01V18C1.25 18.414 1.586 18.75 2 18.75C2.414 18.75 2.75 18.414 2.75 18V16.01C2.75 15.263 2.98299 13.5161 5.14099 13.4301C5.55499 13.4131 5.87601 13.064 5.85901 12.65ZM8.25806 7C8.25806 4.932 9.94106 3.25 12.0081 3.25C14.0751 3.25 15.7581 4.932 15.7581 7C15.7581 9.068 14.0751 10.75 12.0081 10.75C9.94106 10.75 8.25806 9.068 8.25806 7ZM9.75806 7C9.75806 8.241 10.7681 9.25 12.0081 9.25C13.2481 9.25 14.2581 8.241 14.2581 7C14.2581 5.759 13.2481 4.75 12.0081 4.75C10.7681 4.75 9.75806 5.759 9.75806 7ZM13.777 12.139H10.222C6.38705 12.139 5.02698 14.946 5.02698 17.35V20C5.02698 20.414 5.36298 20.75 5.77698 20.75C6.19098 20.75 6.52698 20.414 6.52698 20V17.35C6.52698 16.479 6.79405 13.639 10.222 13.639H13.777C17.206 13.639 17.472 16.479 17.472 17.35V20C17.472 20.414 17.808 20.75 18.222 20.75C18.636 20.75 18.972 20.414 18.972 20V17.35C18.973 14.946 17.612 12.139 13.777 12.139Z" fill="currentColor" />
      </svg>
    },
    {
      title: "Recent Post", path: "/recent-post", color: 'bg-gradient-to-br from-fuchsia-500 to-fuchsia-600', icon: <svg width="24" height="24" className="w-6 h-6 text-white" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M12 12.889L11.4494 13.3983C11.5914 13.5517 11.791 13.639 12 13.639C12.209 13.639 12.4086 13.5517 12.5506 13.3983L12 12.889ZM12.2678 12.5995L12.8183 13.1088V13.1088L12.2678 12.5995ZM11.7322 12.5995L12.2828 12.0902L11.7322 12.5995ZM9.05456 15.4941L9.60513 14.9849H9.60513L9.05456 15.4941ZM10.9289 17.5204L10.3784 18.0297L10.9289 17.5204ZM13.0711 17.5204L13.6216 18.0297L13.0711 17.5204ZM14.9454 15.4941L14.3949 14.9849L14.9454 15.4941ZM13.376 7.58397C13.1462 7.92862 13.2393 8.39427 13.584 8.62404C13.9286 8.8538 14.3943 8.76067 14.624 8.41603L14 8L13.376 7.58397ZM10.624 2.41603C10.8538 2.07138 10.7607 1.60573 10.416 1.37596C10.0714 1.1462 9.60573 1.23933 9.37596 1.58397L10 2L10.624 2.41603ZM5.37596 7.58397C5.1462 7.92862 5.23933 8.39427 5.58397 8.62404C5.92862 8.8538 6.39427 8.76067 6.62404 8.41603L6 8L5.37596 7.58397ZM6 2V2.75H18V2V1.25H6V2ZM2 18H2.75V6H2H1.25V18H2ZM22 6H21.25V18H22H22.75V6H22ZM18 22V21.25H6V22V22.75H18V22ZM22 18H21.25C21.25 19.7949 19.7949 21.25 18 21.25V22V22.75C20.6234 22.75 22.75 20.6234 22.75 18H22ZM2 18H1.25C1.25 20.6234 3.37665 22.75 6 22.75V22V21.25C4.20507 21.25 2.75 19.7949 2.75 18H2ZM18 2V2.75C19.7949 2.75 21.25 4.20507 21.25 6H22H22.75C22.75 3.37665 20.6234 1.25 18 1.25V2ZM6 2V1.25C3.37665 1.25 1.25 3.37665 1.25 6H2H2.75C2.75 4.20507 4.20507 2.75 6 2.75V2ZM12 12.889L12.5506 13.3983L12.8183 13.1088L12.2678 12.5995L11.7172 12.0902L11.4494 12.3797L12 12.889ZM11.7322 12.5995L11.1817 13.1088L11.4494 13.3983L12 12.889L12.5506 12.3797L12.2828 12.0902L11.7322 12.5995ZM9.05456 15.4941L8.504 16.0034L10.3784 18.0297L10.9289 17.5204L11.4795 17.0111L9.60513 14.9849L9.05456 15.4941ZM13.0711 17.5204L13.6216 18.0297L15.496 16.0034L14.9454 15.4941L14.3949 14.9849L12.5205 17.0111L13.0711 17.5204ZM14.9454 12.5995L14.3949 13.1088C14.8684 13.6207 14.8684 14.473 14.3949 14.9849L14.9454 15.4941L15.496 16.0034C16.5013 14.9166 16.5013 13.177 15.496 12.0902L14.9454 12.5995ZM14.9454 12.5995L15.496 12.0902C14.4597 10.9699 12.7535 10.9699 11.7172 12.0902L12.2678 12.5995L12.8183 13.1088C13.2609 12.6304 13.9523 12.6304 14.3949 13.1088L14.9454 12.5995ZM9.05456 12.5995L9.60513 13.1088C10.0477 12.6304 10.7391 12.6304 11.1817 13.1088L11.7322 12.5995L12.2828 12.0902C11.2465 10.9699 9.5403 10.9699 8.504 12.0902L9.05456 12.5995ZM10.9289 17.5204L10.3784 18.0297C11.2668 18.9901 12.7332 18.9901 13.6216 18.0297L13.0711 17.5204L12.5205 17.0111C12.2259 17.3296 11.7741 17.3296 11.4795 17.0111L10.9289 17.5204ZM9.05456 12.5995L8.504 12.0902C7.49867 13.177 7.49867 14.9166 8.504 16.0034L9.05456 15.4941L9.60513 14.9849C9.13162 14.473 9.13162 13.6207 9.60513 13.1088L9.05456 12.5995ZM2 8V8.75H22V8V7.25H2V8ZM18 2L17.376 1.58397L13.376 7.58397L14 8L14.624 8.41603L18.624 2.41603L18 2ZM10 2L9.37596 1.58397L5.37596 7.58397L6 8L6.62404 8.41603L10.624 2.41603L10 2Z" fill="currentColor" />
      </svg>

    },
  ];

  useEffect(() => {
    const LoginData = secureLocalStorage.getItem("Logindata");
    if (LoginData && LoginData !== "null" && LoginData !== "undefined") {
      try {
        const parsed = typeof LoginData === 'string' ? JSON.parse(LoginData) : LoginData;
        if (parsed) {
          setName(parsed.name || "");
          setDate(parsed.date || "");
        }
      } catch (e) {
        console.error("Error parsing Logindata in Dashboard:", e);
      }
    }

    const initDashboard = async () => {
      await Promise.all([
        handleGetPageList(),
        handleGetSavedKundlis()
      ]);
      setLoading(false);
    };
    initDashboard();
  }, []);

  const handleGetPageList = async () => {
    if (PageListRef.current) return;
    PageListRef.current = true;
    try {
      const Response = await HandleCallApi("Get", "user/pages");
      if (Response && Response.data) {
        setPageList(Response.data.pages_data || []);
      }
    } catch (err) {
      console.error("Error getting page list:", err);
    }
  };

  const handleGetSavedKundlis = async () => {
    const uid = secureLocalStorage.getItem("Userid");
    if (uid) {
      try {
        const Response = await HandleCallApi("Post", "user/user_kundlis", { id: uid });
        if (Response && Response.data && Response.data.Result) {
          setSavedKundlis(Response.data.kundli_list || []);
        }
      } catch (err) {
        console.error("Error getting user saved kundlis:", err);
      }
    }
  };

  const handleDownloadPdf = async (kundli) => {
    const uid = secureLocalStorage.getItem("Userid");
    if (!uid || uid === "0") {
      setIsToast(true);
      setToastMsg("Please login to download your Kundli PDF.");
      navigate("/auth/login");
      return;
    }

    const isPremium = secureLocalStorage.getItem("kundli_pdf_status") === "1" || secureLocalStorage.getItem("kundli_pdf_status") === 1;
    const price = Number(secureLocalStorage.getItem("kundli_pdf_price")) || 0;
    const wallet = Number(secureLocalStorage.getItem("userwallet")) || 0;

    if (isPremium) {
      if (wallet < price) {
        setIsToast(true);
        setToastMsg("Insufficient wallet balance! Please recharge to download PDF.");
        navigate("/wallet");
        return;
      }
      setPendingKundli(kundli);
      setShowConfirmModal(true);
    } else {
      proceedDownloadPdf(kundli);
    }
  };

  const proceedDownloadPdf = async (kundli) => {
    const uid = secureLocalStorage.getItem("Userid");
    const isPremium = secureLocalStorage.getItem("kundli_pdf_status") === "1" || secureLocalStorage.getItem("kundli_pdf_status") === 1;
    const price = Number(secureLocalStorage.getItem("kundli_pdf_price")) || 0;
    const wallet = Number(secureLocalStorage.getItem("userwallet")) || 0;

    setDownloadingPdfId(kundli.id);
    try {
      const requestData = {
        id: uid,
        Kundli_id: String(kundli.id),
        wblanguage: kundli.wblanguage || "en"
      };

      const response = await axios({
        url: `${BaseUrl}user/download-kundli-pdf`,
        method: 'POST',
        data: requestData,
        responseType: 'blob',
      });

      if (isPremium) {
        const newBalance = wallet - price;
        secureLocalStorage.setItem("userwallet", newBalance);
      }

      const url = window.URL.createObjectURL(new Blob([response.data]));
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', `${kundli.firstName || 'Kundli'}_Janam_Patri.pdf`);
      document.body.appendChild(link);
      link.click();
      link.remove();

      setIsToast(true);
      setToastMsg("PDF report downloaded successfully!");
    } catch (error) {
      console.error("PDF download error:", error);
      setIsToast(true);
      setToastMsg("Failed to download PDF. Please try again.");
    } finally {
      setDownloadingPdfId(null);
      setPendingKundli(null);
    }
  };

  const handleLogout = () => {
    setIsToast(true);
    setToastMsg("Logout Seccuessfuly !!");
    setIsAuth(false);
    setUserLogin(prev => prev + 1);
    secureLocalStorage.removeItem("isAuthenticated");
    secureLocalStorage.removeItem("Userid");
    secureLocalStorage.removeItem("tex");
    secureLocalStorage.removeItem("Logindata");
    secureLocalStorage.removeItem("currency");
    sessionStorage.clear();
    navigate("/");
  }

  return (
    <div className='dashboard_page'>

      <div className="width_container">

        <div className="section_1 shadow-md">
          <div>
            <h1 className="text-3xl font-bold text-gray-900">{t("Welcome back")}, {name || "User"}!</h1>
            <p className="text-gray-600 mt-1">{t("Manage your astrology services")}</p>
          </div>
          <div className='max-_425_:w-full max-_425_:mt-3'>
            {Userid
              ? <button onClick={handleLogout} className='logout_button hover:shadow-md'>
                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" className='w-4 h-4' viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true"><path d="m16 17 5-5-5-5"></path><path d="M21 12H9"></path><path d="M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4"></path></svg>
                {t("Logout")}
              </button>
              : <Link to="/auth/login" className='logout_button hover:shadow-md'>
                <svg width="18" height="18" viewBox="0 0 24 24" fill="currentColor"
                  xmlns="http://www.w3.org/2000/svg">
                  <path
                    d="M21.75 6V18C21.75 20.418 20.418 21.75 18 21.75H12C9.582 21.75 8.25 20.418 8.25 18V17C8.25 16.586 8.586 16.25 9 16.25C9.414 16.25 9.75 16.586 9.75 17V18C9.75 19.577 10.423 20.25 12 20.25H18C19.577 20.25 20.25 19.577 20.25 18V6C20.25 4.423 19.577 3.75 18 3.75H12C10.423 3.75 9.75 4.423 9.75 6V7C9.75 7.414 9.414 7.75 9 7.75C8.586 7.75 8.25 7.414 8.25 7V6C8.25 3.582 9.582 2.25 12 2.25H18C20.418 2.25 21.75 3.582 21.75 6ZM12.47 14.47C12.177 14.763 12.177 15.238 12.47 15.531C12.616 15.677 12.808 15.751 13 15.751C13.192 15.751 13.384 15.678 13.53 15.531L16.53 12.531C16.599 12.462 16.654 12.379 16.692 12.287C16.768 12.104 16.768 11.897 16.692 11.714C16.654 11.622 16.599 11.539 16.53 11.47L13.53 8.47C13.237 8.177 12.762 8.177 12.469 8.47C12.176 8.763 12.176 9.23801 12.469 9.53101L14.189 11.251H3C2.586 11.251 2.25 11.587 2.25 12.001C2.25 12.415 2.586 12.751 3 12.751H14.189L12.47 14.47Z"
                    stroke="currentColor"
                    strokeWidth="0.5"
                    strokeLinejoin="round"
                    strokeLinecap="round"
                  />
                </svg>
                {t("Login")}
              </Link>}
          </div>
        </div>

        {Userid && <div className={`section_2 grid grid-cols-1 md:grid-cols-2 ${secureLocalStorage.getItem("aishow") === "true" ? "lg:grid-cols-3" : "lg:grid-cols-2"} gap-6 mt-[20px]`}>
          <div>
            <Link to="/wallet" className="card_box bg-[--bgcolor] hover:shadow-lg transition-all text-white">
              <div className='leading-4'>
                <p className="text-[15px] font-medium">{t("Wallet Balance")}</p>
                <p className="text-2xl font-bold mt-1">{formatPrice(Userwallet, 2)}</p>
              </div>
              <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" className='w-12 h-12' viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true"><path d="M19 7V4a1 1 0 0 0-1-1H5a2 2 0 0 0 0 4h15a1 1 0 0 1 1 1v4h-3a2 2 0 0 0 0 4h3a1 1 0 0 0 1-1v-2a1 1 0 0 0-1-1"></path><path d="M3 5v14a2 2 0 0 0 2 2h15a1 1 0 0 0 1-1v-4"></path></svg>
            </Link>
          </div>
          <div>
            <Link to="/profile" className="card_box bg-white border-[1px] shadow-sm hover:shadow-lg transition-all group">
              <div className='leading-4'>
                <p className="text-gray-700 text-[15px] font-medium">{t("My Profile (Member Since)")}</p>
                <p className="text-2xl font-bold mt-1 group-hover:text-[--bgcolor]">{formatDateSafe(date)}</p>
              </div>
              <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="w-12 h-12 text-gray-300" aria-hidden="true"><path d="M19 21v-2a4 4 0 0 0-4-4H9a4 4 0 0 0-4 4v2"></path><circle cx="12" cy="7" r="4"></circle></svg>
            </Link>
          </div>

          {secureLocalStorage.getItem("aishow") === "true" && <div>
            <Link to="/astrologer-ai" className="card_box bg-white border-[1px] shadow-sm hover:shadow-lg transition-all group">
              <div className='leading-4'>
                <p className="text-gray-700 text-[15px] font-medium">{t("Astrologer Ai Assistant")}</p>
                <p className="text-2xl font-bold mt-1 group-hover:text-[--bgcolor]">{t("Chat Now")}</p>
              </div>
              <svg width="24" height="24" className="w-12 h-12 text-gray-300" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M12 21.75C11.665 21.75 11.371 21.528 11.279 21.206L10.5 18.479C9.807 16.054 7.945 14.192 5.521 13.5L2.79401 12.721C2.47201 12.629 2.25 12.335 2.25 12C2.25 11.665 2.47201 11.371 2.79401 11.279L5.521 10.5C7.946 9.807 9.807 7.946 10.5 5.521L11.279 2.79401C11.371 2.47201 11.665 2.25 12 2.25C12.335 2.25 12.629 2.47201 12.721 2.79401L13.5 5.521C14.193 7.946 16.055 9.808 18.479 10.5L21.206 11.279C21.528 11.371 21.75 11.665 21.75 12C21.75 12.335 21.528 12.629 21.206 12.721L18.479 13.5C16.054 14.193 14.193 16.054 13.5 18.479L12.721 21.206C12.629 21.528 12.335 21.75 12 21.75ZM5.73001 12L5.93301 12.058C8.85901 12.894 11.106 15.141 11.943 18.068L12.001 18.27L12.059 18.068C12.896 15.141 15.142 12.895 18.069 12.058L18.27 12L18.067 11.942C15.141 11.106 12.894 8.85901 12.057 5.93201L12 5.73099L11.942 5.93301C11.105 8.86001 8.85901 11.106 5.93201 11.943L5.73001 12Z" fill="currentColor" />
              </svg>
            </Link>
          </div>}

        </div>}

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 mt-[20px]">

          {CardList.map((item, index) => {
            const IsShow = !Userid && (item.title === "Appointment List" || item.title === "My Following");
            const MdHidden = item.title === "Recent Post" || item.title === "Chat With Astrologer";
            if (!IsShow) {
              return <Link to={item.path} key={index} className={`rounded-xl border border-gray-200 bg-white shadow-sm hover:shadow-lg transition-all cursor-pointer group ${MdHidden && "max-_1200_:block hidden"}`}>
                <div className="p-6">
                  <div className="flex items-center justify-between mb-4">
                    <div className={`w-12 h-12 rounded-xl ${item.color} flex items-center justify-center group-hover:scale-110 transition-transform`}>
                      {item.icon}
                    </div>
                  </div>
                  <h3 className="text-lg font-semibold group-hover:text-[--bgcolor] transition-colors">{t(item.title)}</h3>
                </div>
              </Link>
            }
          })}

          {pageList.map((item, index) => {
            const Color = index == 0 ? "bg-gradient-to-br from-cyan-500 to-cyan-600" : "bg-gradient-to-br from-green-500 to-green-600";
            const Title = item.title.replace(/\s+/g, '-').toLowerCase();
            return <Link to={`/pages/${Title}`} key={index} className="rounded-xl border border-gray-200 bg-white shadow-sm hover:shadow-lg transition-all cursor-pointer group">
              <div className="p-6">
                <div className="flex items-center justify-between mb-4">
                  <div className={`w-12 h-12 rounded-xl flex ${Color} items-center justify-center group-hover:scale-110 transition-transform`}>
                    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path d="M17 4.25H16.73C16.633 2.996 15.821 2.25 14.5 2.25H9.5C8.179 2.25 7.36702 2.996 7.27002 4.25H7C4.582 4.25 3.25 5.582 3.25 8V18C3.25 20.418 4.582 21.75 7 21.75H17C19.418 21.75 20.75 20.418 20.75 18V8C20.75 5.582 19.418 4.25 17 4.25ZM8.75 4.5C8.75 3.911 8.911 3.75 9.5 3.75H14.5C15.089 3.75 15.25 3.911 15.25 4.5V5.5C15.25 6.089 15.089 6.25 14.5 6.25H9.5C8.911 6.25 8.75 6.089 8.75 5.5V4.5ZM19.25 18C19.25 19.577 18.577 20.25 17 20.25H7C5.423 20.25 4.75 19.577 4.75 18V8C4.75 6.423 5.423 5.75 7 5.75H7.27002C7.36702 7.004 8.179 7.75 9.5 7.75H14.5C15.821 7.75 16.633 7.004 16.73 5.75H17C18.577 5.75 19.25 6.423 19.25 8V18ZM16.75 12C16.75 12.414 16.414 12.75 16 12.75H11C10.586 12.75 10.25 12.414 10.25 12C10.25 11.586 10.586 11.25 11 11.25H16C16.414 11.25 16.75 11.586 16.75 12ZM16.75 16C16.75 16.414 16.414 16.75 16 16.75H11C10.586 16.75 10.25 16.414 10.25 16C10.25 15.586 10.586 15.25 11 15.25H16C16.414 15.25 16.75 15.586 16.75 16ZM8.75 12C8.75 12.414 8.414 12.75 8 12.75C7.586 12.75 7.25 12.414 7.25 12C7.25 11.586 7.586 11.25 8 11.25C8.414 11.25 8.75 11.586 8.75 12ZM8.75 16C8.75 16.414 8.414 16.75 8 16.75C7.586 16.75 7.25 16.414 7.25 16C7.25 15.586 7.586 15.25 8 15.25C8.414 15.25 8.75 15.586 8.75 16Z" fill="white" />
                    </svg>
                  </div>
                </div>
                <h3 className="text-lg font-semibold group-hover:text-[--bgcolor] transition-colors">{item.title}</h3>
              </div>
            </Link>
          })}

        </div>

        {Userid && (
          <div className="saved_kundlis_section mt-10">
            <div className="flex items-center justify-between mb-6">
              <div>
                <h2 className="text-2xl font-bold text-gray-900 flex items-center gap-2">
                  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" className="text-[--bgcolor] w-6 h-6" xmlns="http://www.w3.org/2000/svg">
                    <path d="M12 2L15.09 8.26L22 9.27L17 14.14L18.18 21.02L12 17.77L5.82 21.02L7 14.14L2 9.27L8.91 8.26L12 2Z" fill="currentColor" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                  </svg>
                  {t("Saved Kundli Profiles")}
                </h2>
                <p className="text-gray-500 text-sm mt-1">{t("Access your saved birth charts and download Janam Patri reports")}</p>
              </div>
              <Link to="/freekundli" className="flex items-center gap-2 bg-[--bgcolor] text-white px-4 py-2 rounded-xl text-sm font-semibold hover:shadow-md transition-all">
                <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"><line x1="12" y1="5" x2="12" y2="19"></line><line x1="5" y1="12" x2="19" y2="12"></line></svg>
                {t("New Kundli")}
              </Link>
            </div>

            {savedKundlis.length === 0 ? (
              <div className="flex flex-col items-center justify-center p-12 bg-white rounded-2xl border border-dashed border-gray-300 text-center">
                <div className="w-16 h-16 bg-orange-50 rounded-full flex items-center justify-center text-[--bgcolor] mb-4">
                  <svg width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"><path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"></path><polyline points="14 2 14 8 20 8"></polyline><line x1="12" y1="18" x2="12" y2="12"></line><line x1="9" y1="15" x2="15" y2="15"></line></svg>
                </div>
                <h3 className="text-lg font-semibold text-gray-800">{t("No Saved Kundli Profiles")}</h3>
                <p className="text-gray-500 text-sm mt-1 mb-6 max-w-sm">{t("Create a free Kundli and save it to access birth charts, planet positions, dasha reports and download PDF patri anytime.")}</p>
                <Link to="/freekundli" className="bg-[--bgcolor] text-white px-6 py-2.5 rounded-xl font-semibold hover:shadow-lg transition-all">
                  {t("Create Free Kundli")}
                </Link>
              </div>
            ) : (
              <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
                {savedKundlis.map((item, index) => {
                  const initials = `${item.firstName?.charAt(0) || ''}${item.lastName?.charAt(0) || ''}`.toUpperCase();
                  const isDownloading = downloadingPdfId === item.id;
                  return (
                    <div key={item.id || index} className="bg-white rounded-2xl border border-gray-200 p-5 shadow-sm hover:shadow-md transition-all flex flex-col justify-between">
                      <div>
                        <div className="flex items-center gap-3 mb-4">
                          <div className="w-10 h-10 rounded-xl bg-orange-50 text-[--bgcolor] flex items-center justify-center font-bold text-sm">
                            {initials || 'K'}
                          </div>
                          <div>
                            <h3 className="font-bold text-gray-900 text-base line-clamp-1">{item.firstName} {item.lastName}</h3>
                            <span className="inline-block text-[11px] bg-orange-50 text-[--bgcolor] font-medium px-2 py-0.5 rounded-full mt-0.5 capitalize">
                              {t(item.wbgender || 'male')}
                            </span>
                          </div>
                        </div>

                        <div className="space-y-2.5 text-sm text-gray-600 mb-5">
                          <div className="flex items-center gap-2">
                            <svg width="16" height="16" className="text-gray-400" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                              <rect x="3" y="4" width="18" height="18" rx="2" ry="2"></rect>
                              <line x1="16" y1="2" x2="16" y2="6"></line>
                              <line x1="8" y1="2" x2="8" y2="6"></line>
                              <line x1="3" y1="10" x2="21" y2="10"></line>
                            </svg>
                            <span>{item.formatted}</span>
                          </div>
                          <div className="flex items-center gap-2">
                            <svg width="16" height="16" className="text-gray-400" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                              <path d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0 1 18 0z"></path>
                              <circle cx="12" cy="10" r="3"></circle>
                            </svg>
                            <span className="line-clamp-1">{item.wb_place}</span>
                          </div>
                        </div>
                      </div>

                      <div className="flex gap-3 pt-3 border-t border-gray-100">
                        <button 
                          onClick={() => navigate("/janam-kundali-details", { state: item })}
                          className="flex-1 bg-amber-50 text-[--bgcolor] border border-amber-200 py-2 px-3 rounded-xl text-xs font-semibold hover:bg-[--bgcolor] hover:text-white transition-all text-center"
                        >
                          {t("View Details")}
                        </button>
                        <button 
                          disabled={isDownloading}
                          onClick={() => handleDownloadPdf(item)}
                          className="flex-1 bg-white border border-gray-300 py-2 px-3 rounded-xl text-xs font-semibold text-gray-700 hover:border-gray-400 hover:bg-gray-50 transition-all flex items-center justify-center gap-1.5"
                        >
                          {isDownloading ? (
                            <Btn_loader CustomeStyle="bg-gray-400" />
                          ) : (
                            <>
                              <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4"></path><polyline points="7 10 12 15 17 10"></polyline><line x1="12" y1="15" x2="12" y2="3"></line></svg>
                              <span>{t("Download PDF")}</span>
                            </>
                          )}
                        </button>
                      </div>
                    </div>
                  );
                })}
              </div>
            )}
          </div>
        )}

      </div>

      {/* Custom Confirmation Modal */}
      {showConfirmModal && (
        <div className="fixed inset-0 z-[9999] flex items-center justify-center bg-black bg-opacity-50 backdrop-blur-sm">
          <div className="bg-white rounded-2xl p-6 max-w-md w-full mx-4 shadow-2xl border border-gray-100 transition-all duration-300">
            <h3 className="text-xl font-bold text-gray-900 mb-3">{t("Confirm Download")}</h3>
            <p className="text-gray-600 mb-6">
              {t("Downloading this premium PDF will deduct")} {formatPrice(Number(secureLocalStorage.getItem("kundli_pdf_price")) || 0)} {t("from your wallet. Do you want to proceed?")}
            </p>
            <div className="flex justify-end gap-3">
              <button
                onClick={() => {
                  setShowConfirmModal(false);
                  setPendingKundli(null);
                }}
                className="px-5 py-2.5 rounded-xl border border-gray-300 text-gray-700 font-semibold text-sm hover:bg-gray-50 active:scale-95 transition-all"
              >
                {t("Cancel")}
              </button>
              <button
                onClick={() => {
                  setShowConfirmModal(false);
                  if (pendingKundli) {
                    proceedDownloadPdf(pendingKundli);
                  }
                }}
                className="px-5 py-2.5 rounded-xl bg-[--bgcolor] hover:bg-opacity-90 text-white font-semibold text-sm shadow-md hover:shadow-lg active:scale-95 transition-all"
              >
                {t("OK")}
              </button>
            </div>
          </div>
        </div>
      )}

      <PageLoading loading={loading} />

    </div>
  )
}

export default Dashboard